export default class ProviderDetailsConstants {
    public static GENERAL_INFORMATION_HEADER = "General Information";
    public static AUTHENTICATION_HEADER = "Authentication";
    public static CONFIGURATION_HEADER = "Configuration";
    public static BASIC_AUTHENTICATION_HEADER = "Basic Authentication Credentials for Progress API";
    public static DESCRIPTION_MAX_LETTERS_COUNT = 1000;
    public static CIID_CUSTOM_STRING= "Custom CIID::";
    public static ALL_SYNC_HOURS = ['00:00','01:00','02:00','03:00','04:00','05:00','06:00','07:00','08:00','09:00','10:00','11:00',
        '12:00','13:00','14:00','15:00','16:00','17:00', '18:00','19:00','20:00','21:00','22:00','23:00']
}